import { render } from "./x3_awa_forest_image.vue?vue&type=template&id=29011e28&scoped=true"
import script from "./x3_awa_forest_image.vue?vue&type=script&lang=js"
export * from "./x3_awa_forest_image.vue?vue&type=script&lang=js"

import "./x3_awa_forest_image.vue?vue&type=style&index=0&id=29011e28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29011e28"]])

export default __exports__